import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=1710451b"
import script from "./Certificados.vue?vue&type=script&lang=js"
export * from "./Certificados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1710451b')) {
      api.createRecord('1710451b', component.options)
    } else {
      api.reload('1710451b', component.options)
    }
    module.hot.accept("./Certificados.vue?vue&type=template&id=1710451b", function () {
      api.rerender('1710451b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/autoridad-certificante/Certificados.vue"
export default component.exports